import React, { useState } from 'react';
import { Col, Row, truncateString } from '../../lib/utils';
import { Body2Regular, Body3Light, Body3Regular, CaptionRegular } from '../../lib/font';
import { colors } from '../../lib/colors';
import { I_EMPTY_V2, I_GREY_CIRCLE } from '../../types/images';
import dayjs from 'dayjs';
import ProfileImage from '../ProfileImage';
import styled from 'styled-components';
import {
    getCommunicationCategoryLabel,
    getKioskContentLabel,
    isKioskCommunicationCategory,
    parseKioskContent,
} from '../../lib/communicationBox';

const Container = styled.div<{ isActive: boolean }>`
    display: flex;
    flex-direction: row;
    width: 1190px;
    height: 80px;
    padding-top: 16px;

    background-color: ${({ isActive }) => (isActive ? '#F0F6FF' : '#FDFEFF')};
    cursor: pointer;
    &:hover {
        background-color: #ecf1fc;
    }
`;

const CommunicationListBody = ({ currentItems, onClickDetailButton, communicationObject }: any) => {
    return (
        <Col
            style={{
                width: 1192,
                minHeight: 184,
                borderRadius: '0px 0px 15px 15px',
                backgroundColor: colors.WHITE_50,
                border: '1px solid #C3D4F4',
                alignItems: 'center',
            }}
        >
            {currentItems && currentItems.length > 0 ? (
                currentItems.map((item: any, index: number) => {
                    const isKiosk = isKioskCommunicationCategory(item.category);
                    const rawContent = item.contents?.[0]?.content ?? '';
                    const parsed = isKiosk ? parseKioskContent(rawContent) : null;
                    const isActionOnlyType =
                        parsed?.type === 'visitor_memo' || parsed?.type === 'trainer_promo_lead';
                    const categoryLabel = parsed
                        ? getKioskContentLabel(parsed.type)
                        : getCommunicationCategoryLabel(item.category);
                    const categoryPillStyle = (() => {
                        if (parsed?.type === 'manager_call') {
                            return { bg: '#FEE2E2', color: '#B91C1C', border: '#FCA5A5' };
                        }
                        if (parsed?.type === 'visitor_memo') {
                            return { bg: '#DBEAFE', color: '#1D4ED8', border: '#BFDBFE' };
                        }
                        if (parsed?.type === 'trainer_promo_lead') {
                            return { bg: '#DCFCE7', color: '#15803D', border: '#BBF7D0' };
                        }
                        if (isKiosk) {
                            return { bg: '#E0E7FF', color: '#4338CA', border: '#C7D2FE' };
                        }
                        return null;
                    })();

                    return (
                        <Container
                            isActive={item._id === communicationObject?._id}
                            onClick={() => onClickDetailButton(item)}
                            key={'comm' + index}
                        >
                            {isActionOnlyType ? (
                                <Row
                                    style={{
                                        width: 48,
                                        height: 30,
                                        marginLeft: 24,
                                        marginRight: 24,
                                    }}
                                />
                            ) : (
                                <Row
                                    style={{
                                        width: 48,
                                        height: 30,
                                        backgroundColor: item.status === 'PENDING' ? colors.ERROR_50 : colors.SUCCESS_50,
                                        borderRadius: 4,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginLeft: 24,
                                        marginRight: 24,
                                    }}
                                >
                                    <CaptionRegular
                                        style={{ color: item.status === 'PENDING' ? colors.ERROR : colors.SUCCESS }}
                                    >
                                        {item.status === 'PENDING' ? '대기' : '완료'}
                                    </CaptionRegular>
                                </Row>
                            )}

                            <div style={{ width: 1, height: 24, backgroundColor: colors.WHITE_50 }} />
                            <Row
                                style={{
                                    width: 108,
                                    height: 24,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: 24,
                                    marginRight: 24,
                                }}
                            >
                                {categoryPillStyle ? (
                                    <span
                                        style={{
                                            padding: '3px 10px',
                                            borderRadius: 999,
                                            fontSize: 12,
                                            fontWeight: 700,
                                            backgroundColor: categoryPillStyle.bg,
                                            color: categoryPillStyle.color,
                                            border: `1px solid ${categoryPillStyle.border}`,
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {categoryLabel}
                                    </span>
                                ) : (
                                    <Body3Regular style={{ color: colors.LAVEL_3 }}>
                                        {categoryLabel}
                                    </Body3Regular>
                                )}
                            </Row>

                            <div style={{ width: 1, height: 24, backgroundColor: colors.WHITE_50 }} />
                            <Row
                                style={{
                                    width: 112,
                                    height: 24,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: 24,
                                    marginRight: 24,
                                }}
                            >
                                <ProfileImage
                                    imageUrl={item?.profileImageUrl}
                                    type="VerySmall"
                                    profileName={item?.profileName || item?.memberName}
                                    profileColorType={item?.profileColorType}
                                />
                                <Body3Regular style={{ color: colors.LAVEL_3, marginLeft: 12 }}>
                                    {truncateString(item.memberName, isKioskCommunicationCategory(item.category) ? 8 : 5)}
                                </Body3Regular>
                            </Row>

                            <div style={{ width: 1, height: 24, backgroundColor: colors.WHITE_50 }} />

                            <Row
                                style={{
                                    width: 112,
                                    height: 24,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: 24,
                                    marginRight: 24,
                                }}
                            >
                                {item.coachName ? (
                                    <>
                                        <ProfileImage
                                            imageUrl={item?.profileImageUrl}
                                            type="VerySmall"
                                            profileName={item?.profileName}
                                            profileColorType={item?.profileColorType}
                                        />
                                        <Body3Regular style={{ color: colors.LAVEL_3, marginLeft: 12 }}>
                                            {item.coachName}
                                        </Body3Regular>
                                    </>
                                ) : (
                                    <Body3Regular style={{ color: colors.LAVEL_2 }}>-</Body3Regular>
                                )}
                            </Row>
                            <div style={{ width: 1, height: 24, backgroundColor: colors.WHITE_50 }} />

                            <Row
                                style={{
                                    width: 404,
                                    height: 48,
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    marginLeft: 24,
                                    marginRight: 24,
                                    whiteSpace: 'pre-wrap',
                                }}
                            >
                                {parsed?.type === 'visitor_memo' ? (
                                    <Col style={{ gap: 2, width: '100%' }}>
                                        <Row style={{ alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                                            <span style={{ fontSize: 13, fontWeight: 700, color: '#111827' }}>
                                                {parsed.name || '이름 없음'}
                                            </span>
                                            {parsed.phone && (
                                                <span style={{ fontSize: 12, color: '#6B7280' }}>
                                                    {parsed.phone}
                                                </span>
                                            )}
                                        </Row>
                                        <Body3Regular
                                            style={{
                                                color: '#4B5563',
                                                display: 'block',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                maxWidth: '100%',
                                            }}
                                        >
                                            {parsed.memo ? `💬 ${parsed.memo}` : '메모 없음'}
                                        </Body3Regular>
                                    </Col>
                                ) : parsed?.type === 'manager_call' ? (
                                    <Row style={{ alignItems: 'center', gap: 8 }}>
                                        <span style={{ fontSize: 14 }}>🔔</span>
                                        <span style={{ fontSize: 13, color: '#B91C1C', fontWeight: 600 }}>
                                            {parsed.reason || '관리자 호출'}
                                        </span>
                                    </Row>
                                ) : parsed?.type === 'trainer_promo_lead' ? (
                                    <Col style={{ gap: 2, width: '100%' }}>
                                        <Row style={{ alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                                            <span style={{ fontSize: 13, fontWeight: 700, color: '#111827' }}>
                                                {parsed.name || '이름 없음'}
                                            </span>
                                            {parsed.phone && (
                                                <span style={{ fontSize: 12, color: '#6B7280' }}>
                                                    {parsed.phone}
                                                </span>
                                            )}
                                            {parsed.categoryName && (
                                                <span style={{ fontSize: 12, color: '#15803D', fontWeight: 700 }}>
                                                    {parsed.categoryName}
                                                </span>
                                            )}
                                        </Row>
                                        <Body3Regular
                                            style={{
                                                color: '#4B5563',
                                                display: 'block',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                maxWidth: '100%',
                                            }}
                                        >
                                            {parsed.desiredTime
                                                ? `희망 시간 ${parsed.desiredTime}`
                                                : parsed.coachName
                                                ? `${parsed.coachName} 강사 신청`
                                                : '강사 홍보판 신청'}
                                        </Body3Regular>
                                    </Col>
                                ) : (
                                    <Body3Regular
                                        style={{
                                            color: colors.LAVEL_3,
                                            display: 'block',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            lineHeight: '1.2em',
                                            maxHeight: '2.4em',
                                            whiteSpace: 'normal',
                                        }}
                                    >
                                        {truncateString(rawContent, 48)}
                                    </Body3Regular>
                                )}
                            </Row>

                            <div style={{ width: 1, height: 24, backgroundColor: colors.WHITE_50 }} />

                            <Row
                                style={{
                                    width: 120,
                                    height: 24,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: 24,
                                    whiteSpace: 'pre-wrap',
                                }}
                            >
                                <Body2Regular style={{ color: colors.LAVEL_3 }}>
                                    {dayjs(item.updatedTime).format('YYYY/MM/DD')}
                                </Body2Regular>
                            </Row>
                        </Container>
                    );
                })
            ) : (
                <Col
                    style={{
                        width: 250,
                        height: 56,
                        marginTop: 56,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <img style={{ width: 24, height: 24 }} src={I_EMPTY_V2} />
                    <Body3Light style={{ marginLeft: 16, color: colors.LAVEL_2 }}>
                        아직 회원에게 온 소통글이 없어요
                    </Body3Light>
                </Col>
            )}
        </Col>
    );
};

export default CommunicationListBody;
